(() => {
  'use strict';

  const METRIC_WIDTHS = [115, 125, 135, 145, 155, 165, 175, 185, 195, 205, 215, 225, 235, 245, 255, 265, 275, 285, 295, 305, 315, 325, 335, 345, 355, 365, 375, 385, 395, 405];
  const METRIC_ASPECTS = [20, 25, 30, 35, 40, 45, 50, 55, 60, 65, 70, 75, 80, 85];
  const METRIC_WHEELS = [12, 13, 14, 15, 16, 16.5, 17, 18, 19, 20, 21, 22, 23, 24, 26, 28, 30];
  const FLOTATION_WHEELS = [8, 10, 12, 13, 14, 15, 16, 16.5, 17, 18, 19, 20, 21, 22, 23, 24, 26, 28, 30];

  const numeric = (value, fallback = 0) => {
    const parsed = Number.parseFloat(value);
    return Number.isFinite(parsed) ? parsed : fallback;
  };

  const clamp = (value, minimum, maximum) => Math.min(maximum, Math.max(minimum, numeric(value, minimum)));

  function nearest(value, values) {
    const target = numeric(value, values[0]);
    return values.reduce((closest, candidate) => (
      Math.abs(candidate - target) < Math.abs(closest - target) ? candidate : closest
    ), values[0]);
  }

  function sanitizeSize(size) {
    if (!size || !size.format) return size;

    if (size.format === 'metric') {
      size.width = nearest(size.width, METRIC_WIDTHS);
      size.aspect = nearest(size.aspect, METRIC_ASPECTS);
      size.rim = nearest(size.rim, METRIC_WHEELS);
      return size;
    }

    size.rim = nearest(size.rim, FLOTATION_WHEELS);
    size.diameter = Math.round(clamp(size.diameter, Math.max(16, size.rim + 2), 54) * 10) / 10;
    size.width = Math.round(clamp(size.width, 1.5, 20) * 20) / 20;
    return size;
  }

  function installPatch() {
    const Constructor = customElements.get('smg-tire-size-lab');
    if (!Constructor || Constructor.prototype.__smgInputGuardInstalled) return;
    Constructor.prototype.__smgInputGuardInstalled = true;

    const originalUpdateForScope = Constructor.prototype.updateForScope;
    const originalCalculateComparison = Constructor.prototype.calculateComparison;
    const originalCalculateAwd = Constructor.prototype.calculateAwd;

    Constructor.prototype.renderFields = function renderFields(scope) {
      const container = this.querySelector(`[data-size-fields="${scope}"]`);
      const size = sanitizeSize(this.sizes[scope]);
      if (!container || !size) return;

      if (size.format === 'metric') {
        container.innerHTML = `
          <div class="smg-tire-lab__field-grid">
            ${this.selectField(scope, 'width', 'Width', 'mm', METRIC_WIDTHS, size.width)}
            ${this.selectField(scope, 'aspect', 'Aspect ratio', '%', METRIC_ASPECTS, size.aspect)}
            ${this.selectField(scope, 'rim', 'Wheel', 'inches', METRIC_WHEELS, size.rim)}
          </div>
        `;
      } else {
        container.innerHTML = `
          <div class="smg-tire-lab__field-grid">
            ${this.numberField(scope, 'diameter', 'Diameter', 'inches', size.diameter, Math.max(16, size.rim + 2), 54, .1)}
            ${this.numberField(scope, 'width', 'Width', 'inches', size.width, 1.5, 20, .05)}
            ${this.selectField(scope, 'rim', 'Wheel', 'inches', FLOTATION_WHEELS, size.rim)}
          </div>
        `;
      }

      this.updateSizeLabel(scope);
    };

    Constructor.prototype.updateForScope = function guardedUpdateForScope(scope) {
      sanitizeSize(this.sizes[scope]);
      this.renderFields(scope);
      this.syncFormatButtons(scope);
      return originalUpdateForScope.call(this, scope);
    };

    Constructor.prototype.calculateComparison = function guardedCalculateComparison(scrollToResults = false) {
      sanitizeSize(this.sizes.one);
      sanitizeSize(this.sizes.two);
      return originalCalculateComparison.call(this, scrollToResults);
    };

    Constructor.prototype.calculateAwd = function guardedCalculateAwd(scrollToResults = false) {
      sanitizeSize(this.sizes.front);
      sanitizeSize(this.sizes.rear);
      return originalCalculateAwd.call(this, scrollToResults);
    };

    document.querySelectorAll('smg-tire-size-lab').forEach((instance) => {
      ['one', 'two', 'front', 'rear'].forEach((scope) => sanitizeSize(instance.sizes && instance.sizes[scope]));
      instance.renderAllFields();
      instance.calculateComparison();
      instance.calculateAwd();
    });
  }

  if (window.customElements) {
    customElements.whenDefined('smg-tire-size-lab').then(installPatch);
  }
})();
